import { render, staticRenderFns } from "./destinationItem.vue?vue&type=template&id=18402cf2&scoped=true&"
import script from "./destinationItem.vue?vue&type=script&lang=js&"
export * from "./destinationItem.vue?vue&type=script&lang=js&"
import style0 from "./destinationItem.vue?vue&type=style&index=0&id=18402cf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18402cf2",
  null
  
)

export default component.exports